import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24706846")

_pushScopeId("data-v-24706846")
const _hoisted_1 = { class: "mypage-page" }
const _hoisted_2 = { class: "mypage-page-top-area" }
const _hoisted_3 = {
  class: "mypage-page-contents",
  ref: "scroll"
}
const _hoisted_4 = { class: "mypage-page-contents-report" }
const _hoisted_5 = { class: "mypage-page-contents-favorites" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MypageSelectTabs = _resolveComponent("MypageSelectTabs")
  const _component_MypageReports = _resolveComponent("MypageReports")
  const _component_PullToRefresh = _resolveComponent("PullToRefresh")
  const _component_MypageFavorites = _resolveComponent("MypageFavorites")
  const _component_FavoritesFolderNameInputDialog = _resolveComponent("FavoritesFolderNameInputDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_MypageSelectTabs, {
        leftTitle: _ctx.reportTitle,
        rightTitle: _ctx.favoritesTitle,
        initialSelect: _ctx.initislSelectTab,
        onSelectTabs: _ctx.selectTabs
      }, null, 8, ["leftTitle", "rightTitle", "initialSelect", "onSelectTabs"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_PullToRefresh, {
            topMargin: 8.5,
            onRefresh: _ctx.refreshReport
          }, {
            default: _withId(() => [
              _createVNode(_component_MypageReports, {
                key: _ctx.updateDisplayKey,
                inquiryStatus: _ctx.inquiryStatus,
                usedFoodList: _ctx.usedFoodList,
                userRanking: _ctx.userRanking,
                historyRecipeList: _ctx.historyRecipeList,
                onClickInquiryStart: _ctx.clickInquiryStart,
                onClickInquiryDetail: _ctx.clickInquiryDetail,
                onClickUsed: _ctx.clickUsed
              }, null, 8, ["inquiryStatus", "usedFoodList", "userRanking", "historyRecipeList", "onClickInquiryStart", "onClickInquiryDetail", "onClickUsed"])
            ]),
            _: 1
          }, 8, ["topMargin", "onRefresh"])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_PullToRefresh, {
            topMargin: 8.5,
            onRefresh: _ctx.refreshFavorites
          }, {
            default: _withId(() => [
              _createVNode(_component_MypageFavorites, {
                key: _ctx.updateDisplayKey,
                foodList: _ctx.foodList,
                recipeList: _ctx.recipeList,
                folderList: _ctx.folderList,
                onAppendFolder: _ctx.appendFolderRequest,
                onMoveFolder: _ctx.moveFolderRequest
              }, null, 8, ["foodList", "recipeList", "folderList", "onAppendFolder", "onMoveFolder"])
            ]),
            _: 1
          }, 8, ["topMargin", "onRefresh"])
        ])
      ])
    ], 512),
    _createVNode(_component_FavoritesFolderNameInputDialog, {
      showDialog: _ctx.isShowAppendFolderDialog,
      key: _ctx.updateInputFolderNameKey,
      onCloseClick: _ctx.closeAppendFolderDialog,
      onAppendClick: _ctx.appendFolderAction
    }, null, 8, ["showDialog", "onCloseClick", "onAppendClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDialog,
      dialogType: _ctx.dialogType,
      title: _ctx.dialogTitle,
      message: _ctx.dialogMessage,
      positiveLabel: _ctx.dialogPositiveButtonLabel,
      negativeLabel: _ctx.dialogNegativeButtonLabel,
      onPositiveClick: _ctx.dialogPositiveHandler,
      onNegativeClick: _ctx.dialogNegativeHandler,
      onCloseClick: _ctx.dialogCloseHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick", "onCloseClick"])
  ]))
})